import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@capacit-com/lara-law-shared-ui";
import { Info } from "lucide-react";

const ProcessingBanner: React.FC = () => {
  return (
    <Alert
      variant="default"
      className="mt-4 mb-2 border-primary/30 bg-primary/10"
    >
      <Info className="text-primary" />
      <AlertTitle className="text-primary">
        Dokument behandles stadig
      </AlertTitle>
      <AlertDescription className="text-foreground/80">
        Dette dokument behandles stadig - nogle funktioner er deaktiveret.
        Fremhævning, dokumentlinks og tekstvalg er ikke tilgængelige, indtil
        behandlingen er færdig.
      </AlertDescription>
    </Alert>
  );
};

export default ProcessingBanner;
